import React, { Component } from 'react';
import { Col, Container, Row  } from 'reactstrap';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { faArrowSquareUp } from '@fortawesome/pro-light-svg-icons';

export class InstallPWA extends Component {

    render() {

        return (
            <Row  >
                <Col xs="12">
                    <h2>Install the Provestor property calculator on your device</h2>
                    <h3>Android users</h3>
                    <ul>
                        <li>Tap the <FontAwesomeIcon icon={faEllipsisV} /> symbol in your browser bar</li>
                        <li>Tap 'Add to Home screen'</li>
                    </ul>
                    <h3>Apple users</h3>
                    <ul>
                        <li>Tap the <FontAwesomeIcon icon={faArrowSquareUp} /> symbol in your browser bar</li>
                        <li>Tap 'Add to Home Screen'</li>
                    </ul>
                </Col>
            </Row>
        );
    }
}



export default connect()(InstallPWA);


// WEBPACK FOOTER //
// ./src/Features/InstallPWA/InstallPWA.jsx